module.exports = __webpack_public_path__ + "2cc411b409f8f68dfc29709519cdadd2.png";